import { render } from "./WeGame.vue?vue&type=template&id=8b17cd28&scoped=true"
import script from "./WeGame.vue?vue&type=script&lang=js"
export * from "./WeGame.vue?vue&type=script&lang=js"

import "./WeGame.vue?vue&type=style&index=0&id=8b17cd28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b17cd28"]])

export default __exports__